import { Component, EventEmitter, Input, Output } from "@angular/core";
import { NgbModal, NgbModalRef } from "@ng-bootstrap/ng-bootstrap";
import { filter, take } from "rxjs/operators";
import { QRCodeSettings } from "../../../models";
import { QrCodeFullPreviewModalComponent } from "@app-cmc/features/common/qr-code-preview/qr-code-full-preview-modal";
import { CFSConnectionService } from "@app-cmc/services";
import { CFSConnectionMessage } from "cfs-communication-pack";
import { ToastService } from "@app-cmc/shared/components/app-toaster";

@Component({
  selector: "app-qr-code-preview",
  templateUrl: "./qr-code-preview.component.html",
  styleUrls: ["./qr-code-preview.component.scss"]
})
export class QrCodePreviewComponent {
  constructor(private modalSvc: NgbModal, private cfsConnectionService: CFSConnectionService, private notificationService: ToastService) {}

  readonly qrCodeSize = 180;
  private isModalOpenRequested = false;
  private isFrameLoaded = false;
  private featureModal: NgbModalRef;
  qrCodeSettings: QRCodeSettings;

  @Input() withCompactPreview = false;
  @Input() disabled = false;

  @Input() set settings(settings: QRCodeSettings) {
    this.qrCodeSettings = settings;

    if (this.isModalOpenRequested && !this.featureModal && settings?.safeHtmlUrl) {
      this.showFullQrCode();
    }
  }

  @Output() clickButton = new EventEmitter<MouseEvent>();
  @Output() openModal = new EventEmitter();
  @Output() contentLoaded = new EventEmitter<boolean>();

  ngOnInit(): void {
    this.cfsConnectionService
      .hideQrCodeOnCmc()
      .pipe(
        filter(() => this.isModalOpenRequested),
        take(1)
      )
      .subscribe((info: CFSConnectionMessage) => {
        const errorMessage: string = info?.hideQrCodeInfo?.error || "";

        if (errorMessage) {
          this.notificationService.danger(errorMessage);
        }

        this.modalSvc.dismissAll();
      });
  }

  iframeLoads(): void {
    if (!this.isFrameLoaded) {
      this.isFrameLoaded = true;

      this.contentLoaded.emit(true);
    }
  }

  onClickOpenQrCodeModalBtn(event: MouseEvent): void {
    this.isModalOpenRequested = true;

    this.clickButton.emit(event);
  }

  private showFullQrCode(): void {
    this.openModal.emit(null);

    this.featureModal = this.modalSvc.open(QrCodeFullPreviewModalComponent, {
      backdrop: "static",
      size: "default",
      centered: true,
      windowClass: "custom"
    });
    const comp: QrCodeFullPreviewModalComponent = this.featureModal.componentInstance;
    comp.settings = this.qrCodeSettings;

    this.featureModal.dismissed.pipe(take(1)).subscribe(() => {
      this.featureModal = null;
    });
  }
}
